import React from "react";

import destination_1 from "../../public/wheretogo-beskydy/moravka/destination_1.png";
import destination_2 from "../../public/wheretogo-beskydy/moravka/destination_2.png";
import destination_3 from "../../public/wheretogo-beskydy/moravka/destination_3.png";
import destination_4 from "../../public/wheretogo-beskydy/moravka/destination_4.png";
import destination_5 from "../../public/wheretogo-beskydy/moravka/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-beskydy/moravka/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-beskydy/moravka/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-beskydy/moravka/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-beskydy/moravka/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Moravka = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Vodní nádrž Morávka</h1>
            <p>
              Vodní nádrž Morávka je údolní přehradní nádrž na řece Morávce u
              stejnojmenné obce v Moravskoslezských Beskydech, vybudovaná v 60.
              letech 20. století. Hlavními účely nádrže jsou shromažďování zásob
              pro výrobu pitné vody a ochrana před povodněmi. Okolí nádrže
              podléhá hygienické ochraně a koupání v ní není povoleno.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>zákaz koupání</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>cyklostezky</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>turistické trasy</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>nádherná příroda</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Nádrž na toku Morávky, byla původně počátkem 50. let
                  připravována v lokalitě u Raškovic, 8 kilometrů níže po proudu
                </li>
                <li>
                  Vodní nádrž Morávka leží na stejnojmenné říčce u stejnojmenné
                  obce. Byla vybudována roku 1964. Plocha jezera je 80 ha,
                  sypaná hráz je 44,5 m vysoká a 396 m dlouhá.
                </li>
                <li>
                  Účelem vodního díla je snížení povodňových průtoků a především
                  zásobování obyvatelstva pitnou vodou. Z tohoto důvodu je
                  rekreační využití značně omezeno v rámci pásma hygienické
                  ochrany - zákaz koupání, rybolovu apod.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Moravka;
